<template>
  <div>
    <drop-mobile
      v-if="isMobile"
      :authenticated="authenticated"
      :collectible="collectible"
      :status="status"
      :revealedTokens="revealedTokens"
      :isPremium="isPremium"
      :PackVideo="PackVideo"
      :params="params"
      @claim="claim"
      @purchase="purchase"
      @revealPack="revealPack"
      @backToDrops="backToDrops"
    />
    <drop-desktop
      v-else
      :authenticated="authenticated"
      :collectible="collectible"
      :status="status"
      :revealedTokens="revealedTokens"
      :isPremium="isPremium"
      :PackVideo="PackVideo"
      :params="params"
      @claim="claim"
      @purchase="purchase"
      @revealPack="revealPack"
      @backToDrops="backToDrops"
    />
  </div>
</template>

<script>
  import Background from '@/assets/Background.png';
  import CollectiblesController from '@/controllers/CollectiblesController';
  import KINGOFKPOP_Premium_PackVideo from '@/assets/drop/kingofkpop-premium.mp4';
  import KINGOFKPOP_PackVideo from '@/assets/drop/kingofkpop.mp4';
  import { mapState, mapActions } from 'vuex';

  export default {
    name: 'Homes',

    components: {
      DropDesktop: () => import('./DropDesktop.vue'),
      DropMobile: () => import('./DropMobile.vue'),
    },

    props: ['isMobile', 'authenticated'],

    data: () => ({
      Background,
      collectible: null,
      status: null,
      revealedTokens: [],
      params: {
        loading: false,
        showPackOpening: false,
        showRevealedPack: false,
        claimingPack: false,
      },
    }),

    watch: {
      user(val) {
        if (val) {
          this.getCollectible();
        }
      },
    },

    computed: {
      ...mapState({
        user: (state) => state.user,
      }),
      PackVideo() {
        if (!this.collectible) {
          return null;
        }

        if (this.collectible.collectibleId === 'kingofkpop') {
          return this.isPremium
            ? KINGOFKPOP_Premium_PackVideo
            : KINGOFKPOP_PackVideo;
        }

        return null;
      },
      collectibleId() {
        return this.$route.params.collectibleId;
      },
      isPremium() {
        return this.$route.path.includes('premium');
      },
    },

    mounted() {
      this.getCollectible();
    },

    methods: {
      ...mapActions({ setTokens: 'setTokens', setUser: 'setUser' }),
      getCollectible: async function() {
        try {
          const collectible = await CollectiblesController.getCollectible(
            this.collectibleId
          );
          collectible.moments.forEach((moment) => {
            if (!moment.foilImageUrl) {
              if (
                collectible.collectibleId === 'btsforarmy' &&
                (moment.rarity === 'common' || moment.rarity === 'rare')
              ) {
                moment.foilImageUrl = moment.imageUrl.slice(0, -4) + '_1.png';
              } else {
                moment.foilImageUrl = moment.imageUrl;
              }
            }
          });
          this.collectible = collectible;
          if (this.user) {
            this.status = await CollectiblesController.getCollectibleStatus(
              this.collectible
            );
          }
        } catch (err) {
          this.$emit('handleError', err);
        }
      },
      purchase: async function(purchaseOption) {
        this.params.claimingPack = true;
        const packs = await CollectiblesController.purchasePack(
          this.collectible,
          purchaseOption
        );
        if (packs && packs.length > 0) {
          window.scrollTo(0, 0);
          this.revealedTokens = packs.reduce((tokens, pack) => {
            return tokens.concat(pack.tokens);
          }, []);
          this.params.showPackOpening = true;
          const user = JSON.parse(JSON.stringify(this.user));
          user.user.points -= purchaseOption.price;
          this.setUser(user);
        } else {
          await this.getCollectible();
        }
        this.params.claimingPack = false;
        this.getTokens();
      },
      claim: async function() {
        this.params.claimingPack = true;
        const pack = await CollectiblesController.claimPack(this.collectible);
        if (pack && pack.tokens) {
          window.scrollTo(0, 0);
          this.revealedTokens = pack.tokens;
          this.params.showPackOpening = true;
        } else {
          await this.getCollectible();
        }
        this.params.claimingPack = false;
        this.getTokens();
      },
      revealPack: function() {
        window.scrollTo(0, 0);
        this.params.showPackOpening = false;
        this.params.showRevealedPack = true;
      },
      backToDrops: function() {
        window.scrollTo(0, 0);
        this.status = { claimable: false };
        this.params.showRevealedPack = false;
        this.getCollectible();
      },
      getTokens: async function() {
        if (this.user) {
          const tokens = await CollectiblesController.getTokens();
          this.setTokens(tokens);
        }
      },
    },
  };
</script>
